import { PlayerConfig } from "../../Config";
import { LayaEnv } from "../../LayaEnv";
import { AssetDb } from "../resource/AssetDb";
import { Utils } from "../utils/Utils";
export class URL {
    static initMiniGameExtensionOverrides() {
        if (LayaEnv.isPreview)
            return;
        Object.assign(this.overrideFileExts, this.safeFileExtConversionMap, PlayerConfig.safeFileExtConversionMap);
        this.hasExtOverrides = true;
        this.usingSafeFileExts = true;
    }
    constructor(url) {
        this._url = URL.formatURL(url);
        this._path = URL.getPath(url);
    }
    get url() {
        return this._url;
    }
    get path() {
        return this._path;
    }
    static get rootPath() {
        return URL.basePaths["~/"];
    }
    static set rootPath(value) {
        URL.basePaths["~/"] = value;
    }
    static formatURL(url, base) {
        if (!url)
            return base || URL.basePath || "";
        if (url.startsWith("res://")) {
            let uuid = url.substring(6);
            let url2 = AssetDb.inst.UUID_to_URL(uuid);
            if (!url2)
                return url;
            url = url2;
        }
        if (url.indexOf(":") == -1 && url.charCodeAt(0) !== 47) {
            let url2 = URL.urlMapping[url];
            let isBr;
            if (url2) {
                if (url2.endsWith("wasm.br")) {
                    url2 = url2.substring(0, url2.length - 3);
                    isBr = true;
                }
                url = url2;
            }
            if (URL.customFormat != null)
                url = URL.customFormat(url);
            let ver = URL.version[url];
            if (ver != null) {
                if (ver == "")
                    url += "?v=" + Date.now();
                else {
                    let i = url.lastIndexOf(".");
                    url = url.substring(0, i) + "-" + ver + url.substring(i);
                }
            }
            if (isBr)
                url += ".br";
            if (base == null) {
                base = URL.basePath;
                for (let k in URL.basePaths) {
                    if (url.startsWith(k)) {
                        if (k.charCodeAt(0) === 126)
                            url = url.substring(k.length);
                        base = URL.basePaths[k];
                        break;
                    }
                }
            }
            url = URL.join(base, url);
        }
        return url;
    }
    static postFormatURL(url) {
        if (URL.hasExtOverrides) {
            let extold = Utils.getFileExtension(url);
            let ext = URL.overrideFileExts[extold];
            if (ext != null)
                url = Utils.replaceFileExtension(url, ext);
        }
        return url;
    }
    static normalize(url) {
        if (url.indexOf("./") == -1)
            return url;
        let parts = url.split("/");
        let len = parts.length;
        let i = 0;
        while (i < len) {
            if (parts[i] == ".") {
                parts.splice(i, 1);
                len--;
                continue;
            }
            else if (parts[i] == '..') {
                let index = i - 1;
                if (index >= 0 && parts[index] !== '..') {
                    parts.splice(index, 2);
                    len -= 2;
                    i--;
                    continue;
                }
            }
            i++;
        }
        parts.length = len;
        return parts.join('/');
    }
    static getResURLByUUID(url) {
        if (Utils.isUUID(url))
            return "res://" + url;
        else
            return url;
    }
    static join(base, path) {
        if (!path)
            return "";
        if (path.indexOf(":") > 0)
            return path;
        if (base) {
            let char1 = path.charCodeAt(0);
            if (char1 !== 126 && char1 !== 47) {
                if (base.charCodeAt(base.length - 1) !== 47)
                    path = base + "/" + path;
                else
                    path = base + path;
            }
        }
        return URL.normalize(path);
    }
    static getPath(url) {
        var ofs = url.lastIndexOf('/');
        return ofs > 0 ? url.substring(0, ofs + 1) : "";
    }
    static getFileName(url) {
        var ofs = url.lastIndexOf('/');
        return ofs > 0 ? url.substring(ofs + 1) : url;
    }
    static getURLVerion(url) {
        var index = url.indexOf("?");
        return index >= 0 ? url.substring(index) : null;
    }
    static overrideExtension(originalExts, targetExt, miniGameOnly) {
        if (miniGameOnly) {
            if (!URL.usingSafeFileExts) {
                for (let ext of originalExts)
                    URL.safeFileExtConversionMap[ext] = targetExt;
                return;
            }
        }
        for (let ext of originalExts)
            URL.overrideFileExts[ext] = targetExt;
        URL.hasExtOverrides = true;
    }
}
URL.version = {};
URL.basePath = "";
URL.basePaths = {};
URL.urlMapping = {};
URL.overrideFileExts = {};
URL.hasExtOverrides = false;
URL.usingSafeFileExts = false;
URL.safeFileExtConversionMap = {
    "rendertexture": "rt.json",
    "videotexture": "rt.json",
    "controller": "controller.json",
    "mc": "mc.bin",
    "mcc": "mcc.json",
    "shader": "shader.txt",
    "fui": "fui.json",
    "glsl": "glsl.txt",
    "skel": "skel.bin",
    "lavm": "lavm.json",
    "bp": "bp.json",
    "tres": "tres.json",
    "lensflare": "lensflare.json",
    "tex2darray": "tex2darray.json",
};
